/**
 * Single source of truth para los estados del embudo "recibidos".
 * 4 columnas finales del Kanban + mapping legacy.
 */

export const ESTADOS_LEADS = {
  nuevo:               { label: "Nuevo",               color: "bg-blue-500" },
  respondido:          { label: "En Curso",            color: "bg-purple-500" },
  presupuesto_enviado: { label: "Presupuesto Enviado", color: "bg-yellow-500" },
  cerrado:             { label: "Cerrado",             color: "bg-red-500" },
};

// Mapeo de estados antiguos → nuevos (para leads no migrados).
export const ESTADO_LEGACY_MAP = {
  contactado:          'respondido',
  pendiente_respuesta: 'respondido',
  cerrado_perdido:     'cerrado',
  cerrado_ganado:      'cerrado',
  // estados del embudo "pedidos" que aparecieron en "recibidos" por error histórico:
  enviado:             'cerrado',
  facturado:           'cerrado',
  finalizado:          'cerrado',
  archivado:           'cerrado',
  borrado:             'cerrado',
  eliminado:           'cerrado',
};

export function normalizeEstadoLead(estado) {
  if (!estado) return 'nuevo';
  if (ESTADOS_LEADS[estado]) return estado;
  return ESTADO_LEGACY_MAP[estado] || estado;
}

export const ESTADOS_LEADS_ABIERTOS = ['nuevo', 'respondido', 'presupuesto_enviado'];
export const ESTADOS_LEADS_CERRADOS = ['cerrado'];

// Estados que NO deben sumar al contador de "pendiente respuesta".
// Incluye los nuevos (cerrado) y los legacy aún sin migrar.
export const ESTADOS_NO_PENDIENTES = [
  'cerrado',
  'cerrado_perdido', 'cerrado_ganado',
  'enviado', 'facturado', 'finalizado', 'archivado', 'borrado', 'eliminado',
];

// True si el flag pendiente_email del lead debe traducirse en un indicador
// visible (icono parpadeante, badge, halo rojo, etc). Defensivo contra leads
// legacy que cerramos sin limpiar pendiente_email.
export function shouldShowPendienteEmail(lead) {
  return !!(lead && lead.pendiente_email && !ESTADOS_NO_PENDIENTES.includes(lead.estado));
}

// Subestados del lead cerrado. Se guarda en lead.cerrado_motivo y se muestra
// como badge en la tarjeta del Kanban en la columna Cerrado.
export const MOTIVOS_CIERRE = {
  ganado:        { label: 'Ganado',         color: 'bg-green-500',   text: 'text-white' },
  perdido:       { label: 'Perdido',        color: 'bg-red-500',     text: 'text-white' },
  spam:          { label: 'Spam',           color: 'bg-gray-500',    text: 'text-white' },
  sin_respuesta: { label: 'Sin respuesta',  color: 'bg-orange-500',  text: 'text-white' },
};

export const MOTIVOS_CIERRE_OPCIONES = Object.entries(MOTIVOS_CIERRE).map(([value, m]) => ({
  value,
  label: m.label,
}));
